import React, { useEffect, useState } from "react";
import Icon from "../media/icon/icons";
import BoyAvtar from "../media/image/profileimage.jpg";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = ({ isOpen, onClose, clientId }) => {
  const userName = sessionStorage.getItem("userName");
  const email = sessionStorage.getItem("email");
  const userRole = sessionStorage.getItem("role");
  const behavior = sessionStorage.getItem("behavior");
  const userId = sessionStorage.getItem("userId");
  const navigate = useNavigate();

  if (!isOpen) return null;

  // const handleEditProfile = () => {
  //   onEditProfile && onEditProfile();
  //   onClose();
  // };

  const handleLogout = () => {
    sessionStorage.clear();

    onClose();
    window.location.href = "/";
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <>
      <div
        className={`profile-dropdown header-dropdowns ${
          isOpen ? "open" : "close"
        }`}
      >
        <div className="header-dropdowns-header">
          <div className="header-dropdowns-title">
            <Icon
              name="user_fill"
              width={20}
              height={20}
              color="#3B82F6"
            ></Icon>
            <p>Profile</p>
          </div>
          <button
            className="header-dropdowns-close-btn"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            <Icon
              name="close_fill"
              width={20}
              height={20}
              color="#6B7280"
            ></Icon>
          </button>
        </div>
        <div className="profile-content">
          <div className="profile-actions">
            <div className="user-info">
              <div className="user-avatar">
                {userRole === "admin" ? (
                  <img src={BoyAvtar} alt="avatar" />
                ) : (
                  <div>{userName ? userName.charAt(0).toUpperCase() : "U"}</div>
                )}
              </div>
              <div className="user-details">
                <h3 className="user-name">{userName}</h3>
                <p className="user-email">{email}</p>
              </div>
            </div>
            {/* <button className="edit-profile-btn">
                <Icon name="edit" width={16} height={16} color="#fff" />
                <span>Edit Profile</span>
              </button> */}
            {/* {behavior === "root" ? <button
      className="edit-profile-btn"
      onClick={() => navigate(`/viewmerchant/${clientId}`)}
    >
      <Icon name="edit" width={16} height={16} color="#fff" />
      <span>Edit Profile</span>
    </button> : <button
      className="edit-profile-btn"
      onClick={() => navigate(`/viewprofile/${userId}`)}
    >
      <Icon name="edit" width={16} height={16} color="#fff" />
      <span>Edit Profile</span>
    </button>}  */}
          </div>
          {/* <hr className="separator" /> */}
          <button className="logout-btn" onClick={handleLogout}>
            <Icon name="profilelogout" width={16} height={16} color="#374151" />
            Log out
            {/* <span>Log Out</span> */}
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileDropdown;
